
const searchParcelLayer = async (whereClause: string) => {
  const response = await fetch(`https://www.horrycounty.org/parcelapp/rest/services/HorryCountyGISApp/MapServer/24/query?where=${whereClause}&outFields=*&returnGeometry=true&outSR=102100&f=json`)
  const data = await response.json()
  return data
}

export const searchByPin = async (pin: string) => {
  const where = `PINtext+LIKE+%27${pin}%25%27`
  return await searchParcelLayer(where)
}

export const searchByTms = async (tms: string) => {
  const where = `TMS+LIKE+%27${tms}%25%27`
  return await searchParcelLayer(where)
}

export const searchByOwnerName = async (ownerName: string) => {
  const tokens = ownerName.split(/[, ]+/)
  const where = tokens.map(token => `LOWER(OwnerName)+LIKE+%27%25${token.toLowerCase().replace(/'/g, "''")}%25%27`).join('+AND+')
  return await searchParcelLayer(where)
}